<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3">
  <div class="container-fluid align-tabs">

    <app-tab [tabItems]='tabItems' [counts]="counts" (tabSelectedEvent)="onTabSelected($event)" [currentTab]="currentTab" [showCheckbox]="true" [enableEmail]="emailOption" (checkboxClickEvent)="setUserInfo($event)"></app-tab>

    <div class="row align-items-center" role="tabpanel" id="{{currentTab}}" attr.aria-labelledby="{{currentTab.split(' ').join('')}}Tab">

       <!-- // ----------------for Common Data table----------------- // -->

    <ng-container *ngIf="currentTab==='updates'">
      <app-notify-updates class="w-100 container-fluid" (updateCountEvent)="counts[0]=$event"></app-notify-updates>
    </ng-container>

    <ng-container *ngIf="currentTab==='project request'">
      <app-access-request class="w-100" (accessCountEvent)="counts[1]=$event"></app-access-request>
    </ng-container>
    </div>
  </div>
</div>
